
export const searchSuggestions = [
  'Cellular Jail', 'Ross Island', 'Corbyn\'s Cove Beach', 'Mahatma Gandhi Marine National Park',
  'Samudrika Naval Marine Museum', 'Chidiya Tapu', 'Radhanagar Beach', 'Elephant Beach',
  'Kalapathar Beach', 'Vijaynagar Beach', 'Neil\'s Cove', 'Scuba Diving Sites',
  'Bharatpur Beach', 'Laxmanpur Beach', 'Natural Bridge', 'Sitapur Beach',
  'Ram Nagar Beach', 'Neil Island Jetty', 'Saddle Peak National Park', 'Ross & Smith Islands',
  'Lamiya Bay Beach', 'Kalpong River', 'Pathi Level Beach',
  'Limestone Caves', 'Mud Volcano', 'Parrot Island', 'Baludera Beach',
  'Boat Ride Through Mangroves', 'Jarwa Reserve', 'Other Attractions',
  'Mud Volcanoes', 'Interesting Fact', 'Location', 'Flora and Fauna',
  'Trekking', 'Camping', 'Bird Watching',
  'Historical Significance', 'Natural Beauty', 'Wildlife', 'Light House',
  'Coral Reefs', 'Beach Activities', 'Activities',
  'Sunset Views', 'Festivals', 'Accessibility',
  'Tribal Dance Performances', 'Island Music Festivals', 'Sea Food Festivals', 'Festivals of Lights',
  'International Yoga Festival', 'Local Art Exhibitions', 'Aberdeen Bazaar', 'Port Blair Food Stalls',
  'Neil Island\'s Local Eateries', 'Little Andaman Food Shacks', 'Havelock Island\'s Seafood Dishes',
  'Local Festivals', 'Nicobar Islands Wildlife Sanctuary', 'Malacca Beach', 'Mount Thullier',
  'Car Nicobar Lighthouse', 'Water Sports', 'Sunset Point', 'Campbell Bay National Park',
  'Great Nicobar Biosphere Reserve', 'Little Nicobar Island', 'Shompens Tribe Experience',
  'Nicobar Island Beaches', 'Trekking Opportunities'
];

export const trainSuggestions = [
  'Park Circus', 'Ballygunge', 'Dhakuria', 'Jadabpur', 'Bagha Jatin',
  'New Garia', 'Garia', 'Narendrapur Halt', 'Sonarpur', 'Subhas Gram',
  'Mallikpur', 'Baruipur', 'Kalyanpur', 'Dakshin Durgapur', 'Hotar',
  'Dhamua', 'Uttar Radhanagar Halt', 'Magra Hat', 'Bahrupiya Halt', 'Sangrampur',
  'Deula', 'Netra', 'Basuldanga', 'Gurudas Nagar', 'Diamond Harbour',
  'Shasan Road', 'Krishnamohan Halt', 'Dhapdhapi', 'Surjyapur', 'Gocharan',
  'Hogla', 'Dakshin Barasat', 'Baharu', 'Jayanagar Majilpur', 'Mathurapur Road',
  'Madhabpur', 'Lakshmikantapur', 'Bidyadharpur', 'Gouripur', 'Champahati',
  'Piali', 'Ghatakpukur', 'Bamangachhi', 'Budge Budge', 'Nangi',
  'Akra', 'Santoshpur', 'Brace Bridge', 'Majherhat', 'Remount Road',
  'Khidirpur', 'Canning', 'Nischindapur', 'Kashinagar Halt', 'Namkhana',
  'Sealdah', 'Bidhan Nagar Road', 'Dum Dum', 'Dum Dum Cantonment'
];


export const metroSuggestions = [
'Dakshineswar','Baranagar','Noapara','Dum Dum','Belgachhia','Shyambazaar',
'Shobhabazar Sutanuti','Girish Park','Mahatma Gandhi Road','Central','Chandni Chowk',
'Esplanade','Park Street','Maidan','Rabindra Sadan','Netaji Bhavan',
'Jatin Das Park','Kalighat','Rabindra Sarobar','Mahanayak Uttam Kumar','Netaji',
'Masterda Surya Sen','Gitanjali','Kavi Nazrul','Shahid Khudiram','Kavi Subhash'
];


